// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"198":"a4d6174e","1718":"c1411268","2082":"1f8238b3","2960":"1f8238b3","3528":"083f6dc2","5540":"1f8238b3"}[chunkId] + ".chunk.css";
};